import api from "../../api.service"
import { getPaginatedResponse } from "../utils"

import queryString from "query-string"

export function getOrgList(queryParams = {}) {
    const qs = queryString.stringify(queryParams)

    return api
        .get(`/v2/orgs?${qs}`)
        .then((res) => getPaginatedResponse(res.data))
        .catch((err) => {
            throw api.getResponseError(err)
        })
}
